import { useMutation } from '@tanstack/react-query';
import { stringify as toQueryString } from 'query-string';
import { useApiClientContext } from '../../surveys/context';
import {
	DonationFrequency,
	IDonationSurveyResponse,
	IEventSurveyResponse,
	ILineItem,
	IOperationResultNoValue,
} from '../../surveys/models/Api';

type EventsPayload = {
	quantity: number;
	response?: IEventSurveyResponse;
	items?: ILineItem[];
	_type: 'EventRegistrationCheckout';
};

type DonationsPayload = {
	donationAmount: number;
	serviceFeeAmount: number;
	donorCoversFees: boolean;
	response: IDonationSurveyResponse;
	isRecurring: boolean;
	donationFrequency?: DonationFrequency;
	_type: 'DonationSurveyCheckout';
};

type Payload = { token: string } & (EventsPayload | DonationsPayload);

export const useClientStripeSessionByToken = ({
	onError,
	onSuccess,
}: {
	onError?: (error: IOperationResultNoValue) => void;
	onSuccess?: (data?: string) => void;
} = {}) => {
	const { apiClient } = useApiClientContext();
	return useMutation({
		mutationFn: ({ token, ...payload }: Payload) => {
			return apiClient.post<string>(`stripe/auth/checkout-session?${toQueryString({ token })}`, {
				...payload,
			});
		},
		onError,
		onSuccess,
	});
};
